// extracted by mini-css-extract-plugin
export default {"button":"yof5TrSjo7RBX3QwLgmx","buttonText":"WYcgrh4bUcEd9IYl8fSC","buttonContent":"TWZmv2MPqIuGqa4KyPHL","buttonIcon":"fiEnhelnfQU4mRYa46l4"};